import styled from "styled-components";
import { mainColor, uBackground } from "../../styles/global";

export const WrapperGoal = styled.div`
  padding: 3rem calc((100vw - 1220px) / 2);
  background: ${uBackground};
  display: flex;
  justify-content: center;
  margin-top: 50px;

  div {
    width: 50%;
    @media screen and (max-width: 768px) {
      width: 92%;
    }
    h1 {
      color: ${mainColor};
      font-family: "Avenir";
      font-weight: 600;
      font-size: 3.5rem;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        line-height: 50px;
        font-family: "Avenir";
        font-style: normal;
        font-weight: 500;
        font-size: 21px;
        line-height: 29px;
        text-align: center;
        letter-spacing: 0.01em;
      }
    }
    p {
      font-family: "Avenir";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 31px;
      letter-spacing: 0.01em;
      color: ${mainColor};
      @media screen and (max-width: 768px) {
        font-family: "Avenir";
        font-style: normal;
        font-weight: 400;
        font-size: 13px;
        line-height: 14px;
        text-align: center;
        letter-spacing: 0.01em;
      }
    }
  }
  @media screen and (max-width: 768px) {
    padding: 3rem 1rem;
  }
`;
